import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'
import Big from 'big.js'
import { refreshPeriodsPerCharge } from 'CreditGrants/creditGrant.billingFrequency'

type GrantPricing = {
  amount: number
  // What the customer pays per charge. Absent means the grant is sold at face
  // value for every refresh period the charge covers.
  costOfCredit?: number
  grantRefreshFrequency: Dashboardv99990101Api.CreditGrants.GrantRefreshFrequency
  billingFrequency?: Dashboardv99990101Api.CreditGrants.GrantBillingFrequency
}

/**
 * The undiscounted price of one charge. `amount` is credited each refresh, and
 * one charge can pay for several refreshes, so $2,500 monthly billed yearly is
 * $30,000.
 */
export const getGrantFaceValue = ({
  amount,
  grantRefreshFrequency,
  billingFrequency
}: GrantPricing): number =>
  Big(amount)
    .times(refreshPeriodsPerCharge(grantRefreshFrequency, billingFrequency))
    .toNumber()

// The price is what each invoice charges. It's below the face value only on a
// discounted grant.
export const getGrantPrice = (pricing: GrantPricing): number =>
  pricing.costOfCredit ?? getGrantFaceValue(pricing)

export const isDiscountedGrant = (pricing: GrantPricing): boolean =>
  getGrantPrice(pricing) < getGrantFaceValue(pricing)
